import "prismjs";
import "prismjs/components/prism-dns-zone-file";
